import { render, staticRenderFns } from "./wholeBagList.vue?vue&type=template&id=fa58955a&scoped=true&"
import script from "./wholeBagList.vue?vue&type=script&lang=js&"
export * from "./wholeBagList.vue?vue&type=script&lang=js&"
import style0 from "./wholeBagList.vue?vue&type=style&index=0&id=fa58955a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa58955a",
  null
  
)

export default component.exports